import React, { Component } from "react";

import { BrowserRouter, Route } from "react-router-dom";

import Layout from "./hoc/Layout/Layout";
import HomePage from "./containers/HomePage/HomePage";
import AboutPage from "./containers/AboutPage/AboutPage";
import LocationPage from "./containers/LocationPage/LocationPage";
import GalleryPage from "./containers/GalleryPage/GalleryPage";
import ServicesPage from "./containers/ServicesPage/ServicesPage";

//place "pages" in the layout as children//
class App extends Component {
   state = {
      page: "home",
   };

   changePageHandler(pageid) {
      this.setState({ page: pageid });
      window.scrollTo(0, 0);
   }

   render() {
      return (
         <div>
            <BrowserRouter>
               <Layout
                  pageid={this.state.page}
                  navclick={(pageid) => this.changePageHandler(pageid)}
               >
                  <Route path="/" exact component={HomePage} />
                  <Route path="/about" exact component={AboutPage} />
                  <Route path="/location" exact component={LocationPage} />
                  <Route path="/gallery" exact component={GalleryPage} />
                  <Route path="/services" exact component={ServicesPage} />
               </Layout>
            </BrowserRouter>
         </div>
      );
   }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js